<template>
    <el-popover
        v-model="visible"
        :width="width"
        :trigger="trigger"
        :placement="placement"
        :offset="offset"
        :popper-options="popperOptions"
        v-on="$listeners"
    >
        <div ref="iframeWrap" class="express-routes-popover" v-loading="loading"></div>
        <span slot="reference"><slot></slot></span>
    </el-popover>
</template>
<script>
import { IframeBridge } from '@qsen/iframe-bridge';
const IframeId = 'expressRoute';
export default {
    name: 'ExpressRoutesPopover',
    props: {
        width: {
            type: Number,
            default: 516
        },
        trigger: {
            type: String,
            default: 'click'
        },
        placement: {
            type: String,
            default: 'right'
        },
        token: String,
        parentShopId: String,
        mailNo: String,
        boundariesElement: {
            type: [String, Object],
            default: 'body'
        },
        offset: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
        }
    },
    computed: {
        popperOptions() {
            return {
                "boundariesElement": this.boundariesElement
            }
        }
    },
    watch: {
        visible(newValue) {
            if (newValue) {
                this.loading = true;
                this.initIframeBridge().then(() => {
                    this.loading = false;
                    this.iframeBridge.sendMessageToChild(IframeId, {
                        type: 'auth',
                        data: {
                            token: this.token,
                            parentShopId: this.parentShopId,
                            mailNo: this.mailNo, 
                        }
                    })
                });
            } else {
                this.iframeBridge.destroy();
                this.iframeBridge = null;
            }
        }
    },
    methods: {
        initIframeBridge() {
            return new Promise((resolve, reject) => {
                if (this.iframeBridge) {
                    resolve();
                    return;
                }
                // 创建实例
                this.iframeBridge = new IframeBridge({
                    allowedOrigins: ['*.meiguanjia.net', window.location.origin], // 允许通信的域名列表
                    timeout: 15 * 1000,  // iframe 加载超时时间（毫秒）
                    debug: true     // 开启调试日志
                });
                this.$nextTick(() => {
                    this.iframeBridge.mount(this.$refs.iframeWrap, {
                        name: IframeId,
                        url: `${window.location.origin}/express/#/routes/1`,
                        height: '520px',
                        width: "100%",
                    }).then(() => {
                        resolve();
                    }).catch(reject);
                })
            })
        },
    }
}
</script>
<style lang="scss">
.express-routes-popover {
    padding: 12px;
}
</style>